import { ToastServiceMethods } from 'primevue/toastservice';

type Severity = 'success' | 'warn' | 'error';
const SUMMARY_BY_SEVERITY: Record<Severity, string> = {
    success: 'Success',
    warn: 'Warning',
    error: 'Error',
};

export function publishToast (toast: ToastServiceMethods, detail: string, severity: Severity, summary?: string, life: number | undefined = 3000): void {
    toast.add({
        severity,
        summary: summary || SUMMARY_BY_SEVERITY[severity],
        detail,
        life,
    });
}

export function clearAllToasts (toast: ToastServiceMethods): void {
    toast.removeAllGroups();
}
